<div class="switch-control">
    <div class="mapboxgl-ctrl-group mapboxgl-ctrl">
        <button *ngIf="is2D" class="mapbox-gl-draw_ctrl-draw-btn" title="3D" (click)="toggle()">
            <strong>3D</strong>
        </button>
        <button *ngIf="!is2D" class="mapbox-gl-draw_ctrl-draw-btn" title="2D" (click)="toggle()">
            <strong>2D</strong>
        </button>
    </div>
</div>